import React from 'react';
import { connect } from 'react-redux';
import PropTypes from '../../types';
import { selectors } from '../../infrastructure/config';
import DeferredPage from './DeferredPage';
import { selectors as caseSelector } from '../../infrastructure/cases';
import SecondaryApplicantWaiting from '../../routes/secondaryApplicantWaiting';

const DeferredSection = ({ bankId, brandId, username, isCaseLoaded, linkCode }) =>
  isCaseLoaded === undefined || isCaseLoaded ? (
    <span />
  ) : linkCode ? (
    <SecondaryApplicantWaiting brandId={brandId} bankId={bankId} />
  ) : (
    <DeferredPage bankId={bankId} username={username} />
  );
DeferredSection.propTypes = {
  bankId: PropTypes.bankId
};

const mapStateToProps = state => ({
  bankId: selectors.bankId(state),
  username: caseSelector.getUsername(state),
  isCaseLoaded: state.loader.get('isCaseLoaded'),
  linkCode: caseSelector.getJointLinkCode(state)
});

export default connect(mapStateToProps, null)(DeferredSection);
